export const ACTIVE_JOBS_LOADING  = "ACTIVE_JOBS_LOADING";
export const SET_ACTIVE_JOBS  = "SET_ACTIVE_JOBS";
export const SET_ACTIVE_JOB_DETAILS  = "SET_ACTIVE_JOB_DETAILS";
export const REMOVE_ACTIVE_JOBS  = "REMOVE_ACTIVE_JOBS";
export const UPDATE_ACTIVE_JOBS  = "UPDATE_ACTIVE_JOBS";
export const ACTIVE_JOBS_SET_FILTER  = "ACTIVE_JOBS_SET_FILTER";
export const ACTIVE_JOBS_SET_PAGES  = "ACTIVE_JOBS_SET_PAGES";